import PropTypes from "prop-types";
import React from "react";

import ReassignRestForm from "v2/components/responsive/ReassignRestForm";

const ReassignRestPage = (props, context) => {
  const {location: {query}, params: {date, id, routeId}, router} = context;
  return (
    <ReassignRestForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}/${id}`,
          query,
        });
      }} />
  );
};

ReassignRestPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default ReassignRestPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/ReassignRestPage.js
 **/